import { ComponentType, FC, useEffect } from 'react';
import { isCanceledPayment, isCompletedPayment } from 'entities/payment';
import { selectCurrentPayment } from 'entities/payment/model';
import { useShallowSelector, useStepper } from 'shared';
import { STEPPER_ROUTES } from 'widgets/buy-package/lib/stepper';

export function withAwaitingPaymentResolve<P extends object>(WrappedComponent: ComponentType<P>): FC<P> {
  const GuardedComponent: FC<P> = (props) => {
    const payment = useShallowSelector(selectCurrentPayment);
    const { replace } = useStepper();

    useEffect(() => {
      if (!payment) return;

      if (isCanceledPayment(payment)) {
        replace(STEPPER_ROUTES.PAYMENT_INITIAL);
        return;
      }

      if (isCompletedPayment(payment)) {
        replace(STEPPER_ROUTES.PAYMENT_SUCCESS);
      }
    }, [payment, replace]);

    return <WrappedComponent {...props} />;
  };

  return GuardedComponent;
}
